const exportRowsToCsv = (headers, items, filename, stats = []) => {
  const escapeCell = (value) => `"${String(value ?? '').replace(/"/g, '""')}"`
  // Stat cards are exported as a separate "label;value" section above the table.
  // Every line is padded to the table width - spreadsheet apps guess the delimiter from
  // the first lines, and "7:42:10" values would otherwise make them split on ":"
  const toLine = cells => [...cells, ...Array(Math.max(headers.length - cells.length, 0)).fill('')].map(escapeCell).join(';')
  const statLines = stats.map(stat => toLine([stat.hint ? `${stat.label} (${stat.hint})` : stat.label, stat.value]))
  const lines = [
    ...(statLines.length ? [...statLines, toLine([])] : []),
    headers.map(header => escapeCell(header.text)).join(';'),
    ...items.map(item => headers.map(header => escapeCell(item[header.value])).join(';'))
  ]
  const blob = new Blob([`\uFEFF${lines.join('\n')}`], { type: 'text/csv;charset=utf-8;' })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

export default exportRowsToCsv
